import React from "react";
import ViewQnaCard from "./viewQnaCard";

const ViewQna = ({ question }) => {
	return (
		<div className="apply-faq-wrap">
			<h3 className="faq-title">FAQ</h3>
			<ul className="faq-list">
				{question.map((q, idx) => (
					<ViewQnaCard key={idx} question={q} />
				))}
			</ul>
		</div>
	);
};

export default ViewQna;
